/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconCrackedShield: {
  name: 'cracked_shield';
  data: string;
} = {
  name: 'cracked_shield',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M566.988 30.803c-50.117 11.145-100.234 19.524-150.351 24.636l-84.455 161.774 55.556 24.666-137.55 226.329 49.561-202.69-26.92-12.26-85.296 23.836 71.008-60.066 52.165-155.833c-82.384.417-164.767-8.958-247.151-30.392h-.001c36.517 31.118 63.113 113.733 63.113 210.951 0 53.023-8.263 101.17-21.282 139.456 37.214 85.381 102.711 146.314 215.024 209.535 109.44-58.268 172.153-115.433 207.685-200.333-14.943-39.517-24.218-91.397-24.218-148.657-.002-97.219 26.595-179.834 63.112-210.952z"/></svg>`,
};
